import { Component, OnInit } from '@angular/core';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';
import { AuthGuardService } from '@sc/pas-common';

@Component({
    templateUrl: './forbidden.component.html',
    styleUrls: ['./forbidden.component.scss']
})

export class ForbiddenComponent implements OnInit {
    url: string;
    intoFaq: boolean;

    constructor(private router: Router, public authGuardService: AuthGuardService) {
        this.url = environment.server.web.legacy + 'portalscnet/productores/homeproductores.aspx'
    }

    goTo(e) {
        this.authGuardService.logOut()
    }

    ngOnInit() {
    }

    goToFaq(e) {
        this.router.navigate(['/faq']);
    }
}
